import api from '@/api/api'
import { checkNested } from '@/plugins/helpers'

const state = {
  dashboards: null,
  dashboard: null,
  extended: null,
  mainOptions: null,
  //src
  territory: null,
  ownership: null,
  //data
  mainAxis: null,
  showForecast: null,
  //cosmetic
  adaptiveScale: null,
  showValues: null,
  fullSize: false,
}

const mutations = {
  LOAD_DASHBOARDS: (state, data) => {
    state.dashboards = data
  },
  LOAD_DASHBOARD: (state, data) => {
    state.dashboard = data
    state.mainOptions = []

    // set territory
    if (checkNested(data, 'options', 'territory')) {
      const initialValue = data.options.territory.values.find(el => el.default === true)
      if (initialValue) {
        state.territory = initialValue.value
        state.mainOptions.push(data.options.territory.code)
      } else {
        state.territory = null
      }
    } else {
      state.territory = null
    }

    // set ownership
    if (checkNested(data, 'options', 'ownership')) {
      const initialValue = data.options.ownership.values.find(el => el.default === true)
      if (initialValue) {
        state.ownership = initialValue.value
        state.mainOptions = state.mainOptions.push(data.options.ownership.code)
      } else {
        state.ownership = null
      }
    } else {
      state.ownership = null
    }

    // set showValues
    if (checkNested(data, 'options', 'showValues')) {
      const initialValue = data.options.showValues.values.find(el => el.default === true)
      if (initialValue) {
        state.showValues = initialValue.default
      } else {
        state.showValues = false
      }
    } else {
      state.showValues = null
    }

    // set showForecast
    if (checkNested(data, 'options', 'showForecast')) {
      const initialValue = data.options.showForecast.values.find(el => el.default === true)
      if (initialValue) {
        state.showForecast = initialValue.default
      } else {
        state.showForecast = false
      }
    } else {
      state.showForecast = null
    }

    // set adaptiveScale
    if (checkNested(data, 'options', 'adaptiveScale')) {
      const initialValue = data.options.adaptiveScale.values.find(el => el.default === true)
      if (initialValue) {
        state.adaptiveScale = initialValue.default
      } else {
        state.adaptiveScale = false
      }
    } else {
      state.adaptiveScale = null
    }

    // set mainAxis
    if (checkNested(data, 'mainAxis')) {
      const mainAxis = data.mainAxis.values.filter(obj => {
        return obj.default === true
      })

      state.mainAxis = mainAxis
    } else {
      state.mainAxis = null
    }
  },
  LOAD_EXTENDED: (state, data) => {
    state.extended = data
  },
  CHANGE_TERRITORY: (state, data) => {
    state.territory = data
  },
  CHANGE_OWNERSHIP: (state, data) => {
    state.ownership = data
  },
  TOGGLE_SHOW_FORECAST: (state, data) => {
    state.showForecast = data
  },
  TOGGLE_ADAPTIVE_SCALE: (state, data) => {
    state.adaptiveScale = data
  },
  TOGGLE_SHOW_VALUES: (state, data) => {
    state.showValues = data
  },
  TOGGLE_FULLSIZE: state => {
    state.fullSize = !state.fullSize
  },
  TOGGLE_MAIN_AXIS: (state, data) => {
    const index = state.mainAxis.findIndex(el => {
      return el.value === data
    })
    state.mainAxis[index].default = !state.mainAxis[index].default
  },
}

const actions = {
  loadDashboards: ({ commit }) => {
    return new Promise((resolve, reject) => {
      api
        .getDashboards()
        .then(response => {
          commit('LOAD_DASHBOARDS', response.data)
          resolve(response)
        })
        .catch(error => {
          reject(error)
          console.log(error)
        })
    })
  },

  loadDashboard: ({ commit }, id) => {
    return new Promise((resolve, reject) => {
      api
        .getDashboard(id)
        .then(response => {
          commit('LOAD_DASHBOARD', response.data)
          resolve(response)
        })
        .catch(error => {
          reject(error)
          console.log(error)
        })
    })
  },

  loadExtended: ({ commit }, data) => {
    const { id, extendedId, comparedId } = data
    return new Promise((resolve, reject) => {
      api
        .getExtended(id, extendedId, comparedId)
        .then(response => {
          commit('LOAD_EXTENDED', response.data)
          resolve(response)
        })
        .catch(error => {
          reject(error)
          console.log(error)
        })
    })
  },

  changeTerritory: ({ commit }, data) => {
    commit('CHANGE_TERRITORY', data)
  },
  changeOwnership: ({ commit }, data) => {
    commit('CHANGE_OWNERSHIP', data)
  },
  toggleAdaptiveScale: ({ commit }, data) => {
    commit('TOGGLE_ADAPTIVE_SCALE', data)
  },
  toggleShowForecast: ({ commit }, data) => {
    commit('TOGGLE_SHOW_FORECAST', data)
  },
  toggleMainAxis: ({ commit }, data) => {
    commit('TOGGLE_MAIN_AXIS', data)
  },
  toggleShowValues: ({ commit }, data) => {
    commit('TOGGLE_SHOW_VALUES', data)
  },
  toggleFullSize: ({ commit }) => {
    commit('TOGGLE_FULLSIZE')
  },
}

const getters = {
  dashboard: state => {
    return state.dashboard
  },
  extended: state => {
    return state.extended
  },
  mainOptions: state => {
    return state.mainOptions
  },
  territory: state => {
    return state.territory
  },
  ownership: state => {
    return state.ownership
  },
  mainAxis: state => {
    return state.mainAxis
  },
  showForecast: state => {
    return state.showForecast
  },
  adaptiveScale: state => {
    return state.adaptiveScale
  },
  showValues: state => {
    return state.showValues
  },
  fullSize: state => {
    return state.fullSize
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
